/**
 * M List results: count, grid of listing cards, load more, categories cards, bottom CTA.
 */
import React from "react";
import { Link } from "react-router-dom";
import MListListingCard from "./MListListingCard";

export default function MListResultsSection({
  listings,
  loading,
  loadingMore,
  onLoadMore,
  nextOffset,
  categories,
  sortFeatured,
  onSortFeaturedChange,
  hasDataFromApi = true,
  tagIdToTag = {},
}) {
  const hasListings = Array.isArray(listings) && listings.length > 0;

  return (
    <section className="twentytwentysix-content__section">
      {loading && (
        <p className="twentytwentysix-content__copy">Loading…</p>
      )}

      {!loading && (
        <>
          <div className="twentytwentysix-content__mlist-results-header">
            <h2 className="twentytwentysix-content__subtitle">
              {hasListings ? `Listings (${listings.length})` : "Listings"}
            </h2>
            <label className="twentytwentysix-content__mlist-featured-toggle">
              <input
                type="checkbox"
                checked={!!sortFeatured}
                onChange={(e) => onSortFeaturedChange(e.target.checked)}
              />
              <span>Featured first</span>
            </label>
          </div>

          {hasListings ? (
            <>
              <ul className="twentytwentysix-content__list twentytwentysix-content__list--no-bullets twentytwentysix-content__listing-grid">
                {listings.map((entry) => (
                  <MListListingCard key={entry.id} entry={entry} tagIdToTag={tagIdToTag} />
                ))}
              </ul>
              {nextOffset != null && (
                <div className="twentytwentysix-content__cta-row" style={{ marginTop: 24 }}>
                  <button
                    type="button"
                    className="twentytwentysix-content__pill"
                    onClick={onLoadMore}
                    disabled={loadingMore}
                  >
                    {loadingMore ? "Loading…" : "Load more"}
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="twentytwentysix-content__empty-listings">
              <p className="twentytwentysix-content__copy">
                {hasDataFromApi
                  ? "No listings match your filters. Try changing or clearing them."
                  : "No listings available right now."}
              </p>
            </div>
          )}

          <h2 className="twentytwentysix-content__subtitle" style={{ marginTop: 40 }}>Categories</h2>
          <div className="twentytwentysix-content__card-grid">
            {(categories || []).map((cat) => (
              <div className="twentytwentysix-content__card" key={cat.id ?? cat.title}>
                <h4>{cat.title ?? cat.name}</h4>
                <ul className="twentytwentysix-content__list">
                  {((cat.tags && cat.tags.length) ? cat.tags : (cat.items || [])).map((item) => (
                    <li key={typeof item === "object" ? item.slug || item.id : item}>
                      {typeof item === "object" ? (item.name || item.slug) : item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <p className="twentytwentysix-content__copy">
            Want your business on the M List? Apply to join — we review every submission.
          </p>
          <div className="twentytwentysix-content__cta-row">
            <Link to="/twentytwentysix/contact" className="twentytwentysix-content__pill twentytwentysix-content__pill--outline">
              Contact us
            </Link>
          </div>
        </>
      )}
    </section>
  );
}
